import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DriversReportTotalIdleChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.idleTime.total",
		title: "Total Idle Duration",
		yAxisLabel: "Duration (Hours)"
	} ),

	computed: {
		itemsAverageValue() {
			if ( this.averageValue ) {
				return ( this.averageValue / 3600 ).toFixed( 1 );
			}
		},

		barData() {
			if ( this.item ) {
				return [
					( this.item.stats.idleTime.total / 3600 ).toFixed( 1 ),
					this.itemsAverageValue
				];
			}

			return this.items.map( item =>
				( item.stats.idleTime.total / 3600 ).toFixed( 1 )
			);
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name );
		}
	}
};
